var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',_vm._g({staticClass:"base-chip",class:{ __small: _vm.small, __primary: _vm.primary, __round: _vm.round, __outlined: _vm.outlined, __flat: _vm.flat },style:({ height: _vm.height + 'px' })},_vm.$listeners),[_vm._t("default")],2)}
var staticRenderFns = []

export { render, staticRenderFns }